// Truncated text shows its full value on hover (Design, PRD-1361; the pattern
// the ResAI update adopts). Attach as `onMouseEnter` to the element that
// carries `text-overflow: ellipsis`: it sets a native tooltip only while the
// text is actually cut off, so short names get no redundant tooltip.
export function showFullTextIfTruncated(e) {
  const el = e.currentTarget;
  el.title = el.scrollWidth > el.clientWidth ? el.textContent : '';
}
